module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loadComponent) ? _c('div', {
    staticClass: "main-body"
  }, [_c('h1', [_vm._v("\n      " + _vm._s(_vm.$t('static.dashboard.title')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "notificationWrapper"
  }, [(!_vm.account.verified) ? _c('div', {
    staticClass: "notification"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   \n        " + _vm._s(_vm.$t('static.dashboard.emailConfirmationWarning1')) + "\n        "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resendConfirmation($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('static.dashboard.emailConfirmationWarning2')) + "\n        ")]), _vm._v("\n        " + _vm._s(_vm.$t('static.dashboard.emailConfirmationWarning3')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "notificationWrapper"
  }, [(_vm.confirmationResent) ? _c('div', {
    staticClass: "notification"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   \n        " + _vm._s(_vm.$t('static.dashboard.emailConfirmationResentWarning')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "notificationWrapper"
  }, [(_vm.confirmationResentError) ? _c('div', [_c('el-alert', {
    attrs: {
      "title": "$t('static.dashboard.emailConfirmationResentError')",
      "type": "error",
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notificationWrapper"
  }, [(!_vm.account.subscribed) ? _c('div', {
    staticClass: "notification"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   \n          " + _vm._s(_vm.$t('static.dashboard.expiredSubscriptionWarning')) + "\n        ")]) : _vm._e()])]), _vm._v(" "), (_vm.account.verified) ? _c('div') : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-body dashboard-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('div', {
    staticClass: "el-col-lg-24"
  }, [_c('el-button', {
    staticClass: "btn-add-widgets",
    on: {
      "click": function($event) {
        return _vm.widgetsAdd()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.dashboard.addWidgetBtn')))])], 1)]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.cardItems), function(card, index) {
    return (_vm.cardItems) ? _c('el-col', {
      staticClass: "wrap box-card el-card--wide widgets-item",
      attrs: {
        "xs": 24,
        "md": 12,
        "lg": 12,
        "xl": 8
      }
    }, [_c('el-card', [_c('div', {
      staticClass: " widget-card-header"
    }, [_c('div', {
      staticClass: "card-header-item title"
    }, [_c('h2', [_vm._v(_vm._s(card.title) + " "), _c('i', {
      staticClass: "el-icon-info tooltip widget-tooltip"
    }, [_c('span', {
      staticClass: "tooltiptext"
    }, [_vm._v(_vm._s(card.desc))])])]), _vm._v(" "), _c('span', {
      staticClass: "widget-subtitle"
    }, [_vm._v(_vm._s(card.sub))])]), _vm._v(" "), _c('div', {
      staticClass: "card-header-item order"
    }, [_c('el-select', {
      staticClass: "widgets-order-select",
      attrs: {
        "placeholder": "Select"
      },
      on: {
        "change": function($event) {
          return _vm.onChangePos($event, index)
        }
      },
      model: {
        value: (_vm.cardCurrentOrder[index]),
        callback: function($$v) {
          _vm.$set(_vm.cardCurrentOrder, index, $$v)
        },
        expression: "cardCurrentOrder[index]"
      }
    }, _vm._l((_vm.cardItems.length), function(pos, index2) {
      return _c('el-option', {
        key: index2,
        attrs: {
          "label": index2 + 1,
          "value": index2
        }
      })
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "card-header-item close"
    }, [_c('i', {
      staticClass: "el-dialog__close el-icon el-icon-close align-right",
      on: {
        "click": function($event) {
          return _vm.widgetsRemove(index)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "widget-card-body"
    }, [_c('div', {
      staticClass: "widget-chart"
    }, [(card.key === 'widget_1') ? _c('popular-product') : (card.key === 'widget_2') ? _c('amount-revenue') : (card.key === 'widget_3') ? _c('top-clients') : (card.key === 'widget_4') ? _c('waiting-processed') : (card.key === 'widget_5') ? _c('waiting-delivered') : (card.key === 'widget_6') ? _c('order-received') : _vm._e(), _vm._v(" "), (card.key === 'widget_7') ? _c('sold-product') : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "widget-others"
    })])])], 1) : _vm._e()
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4134cf84","hasScoped":false}!./src/app/pages/withNavigation/dashboard/dashboard.html
// module id = 2981
// module chunks = 1